<template>
  <div v-for="item in time" :key="item" class="text-start m-1 mt-3 ms-4 mb-4">
    <div class="fw-bold mb-2">{{ item.name }}</div>
    <div class="d-flex style-vertical-scrolling" v-if="item.timeslots.length">
      <div
        class="scss-click-effect pt-3 pb-3 ps-4 pe-4 me-3 mb-2 rounded style-time-slot-container"
        v-for="timeslot in item.timeslots"
        :key="timeslot"
        :class="{ 'style-time-slot-selected': selectedTime === timeslot }"
        @click="$emit('update:selectedTime', timeslot)"
      >
        {{ timeslot }}
      </div>
    </div>
    <div v-else class="d-flex justify-content-center py-2">
      No available timeslots.
    </div>
  </div>
</template>
<script>
export default {
  name: "TimeSlotSelection",
  props: {
    time: Array,
    selectedTime: String,
  },
};
</script>
<style lang="scss" scoped>
.style-time-slot-container {
  border: 1px solid #d1d1d1;
}

.style-time-slot-selected {
  background-color: $text-blue;
  color: white;
}
</style>
